import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './App.css';
import logo from './assets/logo.png';

const API_BASE_URL = '';

function App() {
  const [password, setPassword] = useState(localStorage.getItem('auth_password') || '');
  const [sessionId] = useState(uuidv4());
  const [lastModified, setLastModified] = useState('');
  const [csvFile, setCsvFile] = useState(null);
  const [xlsxFile, setXlsxFile] = useState(null);
  const [rpdFile, setRpdFile] = useState(null);
  const [rpdStatus, setRpdStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false); // ✅ NOWOŚĆ

  useEffect(() => {
    if (!password) {
      const pw = prompt('Podaj hasło dostępu:');
      if (pw) {
        setPassword(pw);
        localStorage.setItem('auth_password', pw);
      }
    }
  }, [password]);

  useEffect(() => {
    if (!password) return;

    fetch(`${API_BASE_URL}/api/rpd-info`, {
      headers: { 'X-Auth': password }
    })
      .then(res => res.json())
      .then(data => {
        if (data.last_modified) {
          const utcDate = new Date(data.last_modified);
          const offsetMs = new Date().getTimezoneOffset() * 60000;
          const localDate = new Date(utcDate.getTime() - offsetMs);

          const formatted = localDate.toLocaleString('pl-PL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });

          setLastModified(formatted);
        } else {
          setLastModified('Brak informacji');
        }
      });
  }, [password]);

  const downloadRpd = () => {
    window.open(`${API_BASE_URL}/api/download-rpd?auth=${encodeURIComponent(password)}`, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!csvFile || !xlsxFile || !password) return alert('Wybierz pliki i ustaw hasło');

    const formData = new FormData();
    formData.append('csvFile', csvFile);
    formData.append('xlsxFile', xlsxFile);
    formData.append('session_id', sessionId);

    setIsLoading(true); // ✅ START ładowania

    try {
      const res = await fetch(`${API_BASE_URL}/api/upload`, {
        method: 'POST',
        headers: { 'X-Auth': password },
        body: formData
      });

      if (res.ok) {
        const disposition = res.headers.get('Content-Disposition');
        let filename = 'plik.xlsx';

        if (disposition && disposition.includes('filename=')) {
          const match = disposition.match(/filename[^;=\n]*=((['\"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.download = filename;
        a.href = url;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        alert('Błąd podczas generowania pliku');
      }
    } catch (error) {
      alert('Błąd podczas komunikacji z serwerem');
    } finally {
      setIsLoading(false); // ✅ STOP ładowania
    }
  };

  const handleRpdUpload = async () => {
    if (!rpdFile) return setRpdStatus('❌ Nie wybrano pliku');

    const formData = new FormData();
    formData.append('rpdFile', rpdFile);

    setRpdStatus('⏳ Wysyłanie pliku...');

    try {
      const res = await fetch(`${API_BASE_URL}/api/upload-rpd`, {
        method: 'POST',
        headers: { 'X-Auth': password },
        body: formData
      });

      const data = await res.json();

      if (res.ok) {
        setRpdStatus('✅ Plik .rpd został zapisany');
      } else {
        setRpdStatus(`❌ Błąd: ${data.error}`);
      }
    } catch (err) {
      setRpdStatus(`❌ Błąd połączenia z serwerem`);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_password');
    setPassword('');
    alert('Hasło zostało usunięte. Zostaniesz poproszony o ponowne podanie.');
  };

  return (
    <div className="container">
      <h1>Stany magazynowe leków refundowanych</h1>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={handleLogout}>Wyloguj (usuń hasło)</button>
      </div>

      <section>
        <h2>Plik .rpd</h2>
        <div style={{ marginTop: '1rem' }}>
          <label>
            Wybierz plik .rpd:<br />
            <input type="file" accept=".rpd" onChange={e => setRpdFile(e.target.files[0])} />
          </label>
          <button type="button" onClick={handleRpdUpload} style={{ marginLeft: '1rem' }}>
            Wyślij plik .rpd
          </button>
        </div>

        {rpdStatus && (
          <p style={{ marginTop: '0.5rem', color: rpdStatus.startsWith('✅') ? 'green' : 'red' }}>
            {rpdStatus}
          </p>
        )}

        <p>Data ostatniej edycji: {lastModified}</p>
        <button onClick={downloadRpd}>Pobierz plik</button>
      </section>

      <section>
        <h2>Prześlij pliki</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label>
              Plik CSV – stan magazynowy apteki:<br />
              <input style={{ marginTop: '0.25rem' }} type="file" accept=".csv" onChange={e => setCsvFile(e.target.files[0])} />
            </label>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label>
              Plik XLSX – załącznik do rozporządzenia (leki refundowane):<br />
              <input style={{ marginTop: '0.25rem' }} type="file" accept=".xlsx" onChange={e => setXlsxFile(e.target.files[0])} />
            </label>
          </div>

          <button type="submit">Wyślij i pobierz nowy plik</button>
        </form>
      </section>

      <footer style={{
        textAlign: 'center',
        padding: '1rem',
        borderTop: '1px solid #ccc'
      }}>
        <img
          src={logo}
          alt="BORO Advertisement Logo"
          style={{ maxHeight: '40px', width: 'auto', display: 'block', margin: '0 auto 0.5rem' }}
        />
        <p style={{ margin: 0, fontSize: '0.9rem', color: '#555' }}>
          Aplikacja stworzona przez eBORO – profesjonalne rozwiązania dla farmacji.
        </p>
      </footer>

      {/* ✅ Spinner overlay */}
      {isLoading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
}

export default App;
